export const generatorFiles = [
  {
    title: "Verkeer",
    visible: true,
    reports: [
      {
        title: "art. 5 wvw verhoor verdachte",
        type: "conceptreport",
        path: "files/art9.yml",
        enabled: false
      },
      {
        title: "art. 5a wvw verhoor verdachte",
        type: "conceptreport",
        path: "files/art5a.yml",
        enabled: true
      },
      {
        title: "art. 7 wvw verhoor verdachte",
        type: "conceptreport",
        path: "files/art9.yml",
        enabled: false
      },
      {
        title: "art. 9 wvw verhoor verdachte",
        type: "conceptreport",
        path: "files/art9.yml",
        enabled: true
      },
      {
        title: "pv aanrijding verhoor verdachte",
        type: "conceptreport",
        path: "files/verhoor-aanrijding.yml",
        enabled: true
      },
      {
        title: "pv snelheid verhoor verdachte",
        type: "conceptreport",
        path: "files/verhoor-snelheid.yml",
        enabled: true
      },
      {
        title: "pv adr-lachgas verhoor verdachte",
        type: "adrinfosheet",
        path: "files/adr.yml",
        enabled: true
      }
    ]

  },
  {
    title: "Aangifte",
    visible: true,
    reports: [
      {
        title: "inbraak woning",
        type: "conceptreport",
        path: "files/aangifte-inbr-woning.yml",
        enabled: true
      },
      {
        title: "mishandeling",
        type: "conceptreport",
        path: "files/aangifte-mishandeling.yml",
        enabled: true
      },
      {
        title: "diefstal",
        type: "conceptreport",
        path: "files/art9.yml",
        enabled: false
      },
      {
        title: "vernieling",
        type: "conceptreport",
        path: "files/art9.yml",
        enabled: false
      }
    ]
  },
  {
    title: "Getuige",
    visible: true,
    reports: [
      {
        title: "mishandeling",
        type: "conceptreport",
        path: "files/getuige-mishandeling.yml",
        enabled: true
      },
      {
        title: "diefstal",
        type: "conceptreport",
        path: "files/getuige-diefstal.yml",
        enabled: false
      },
      {
        title: "vernieling",
        type: "conceptreport",
        path: "files/getuige-vernieling.yml",
        enabled: false
      }
    ]
  },
  {
    title: "Overig",
    visible: true,
    reports: [
      {
        title: "vragenlijst vermissing",
        type: "infosheet",
        path: "files/vermissing.yml",
        enabled: true
      },
      {
        title: "afstandsverklaring",
        type: "waiver",
        path: "files/afstandsverklaring.yml",
        enabled: true
      }
    ]
  }
];
